// extracted by mini-css-extract-plugin
export default {"champ28":"Champ_champ28__QRAlT","champ32b":"Champ_champ32b__hwvuS","champ90":"Champ_champ90__q4Kfc"};